import httpClient from '@/api/http-client';

const endpoint = 'api/print-log';

const printLogService = {
  getList: (params) => httpClient.get(endpoint, { params }),

  getReport: (params) => httpClient.get(`${endpoint}-report`, { params }),

  logPrint: (print) => httpClient.post(endpoint, print),
};

export default printLogService;
